let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eU1VP")).then(() => parcelRequire('5BbQk'));